import { useCallback, useEffect, useState } from "react";
import GoogleMapFrame from "../../../../../commons/googleMaps/googleMapFrame/GoogleMapFrame";
import GoogleMapFramePending from "../../../../../commons/googleMaps/googleMapFrame/GoogleMapFramePending";
import useMapFrameChannel from "../../../../../commons/hooks/googleMaps/useMapFrameChannel";
import AgenciasMapShell from "./AgenciasMapShell";
import { ARGENTINA_CENTER } from "./mapConstants";

const AgenciasMapFrame = () => {
  const { apiKey, payload } = useMapFrameChannel();
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    setSelectedId(
      payload?.selectedAgenciaId != null ? String(payload.selectedAgenciaId) : "",
    );
  }, [payload]);

  const selectHandler = useCallback((id) => {
    setSelectedId(String(id));
    window.parent.postMessage(
      { type: "select", idAgencia: id },
      window.location.origin,
    );
  }, []);

  if (!apiKey || !payload) return <GoogleMapFramePending />;

  return (
    <GoogleMapFrame apiKey={apiKey}>
      <AgenciasMapShell
        agenciaMarkers={payload.agenciaMarkers || []}
        apiKey={apiKey}
        destinoLabel={payload.destinoLabel}
        destinoLocation={payload.destinoLocation}
        initialCenter={payload.initialCenter || ARGENTINA_CENTER}
        initialZoom={payload.initialZoom || 10}
        onSelectAgencia={payload.interactive ? selectHandler : null}
        origenLabel={payload.origenLabel}
        origenLocation={payload.origenLocation}
        selectedId={selectedId}
        viewportLocations={payload.viewportLocations || []}
      />
    </GoogleMapFrame>
  );
};

export default AgenciasMapFrame;
